module.exports = __webpack_public_path__ + "img/bannerjituan.f71d9ed9.png";